export function roundNumber(number: number, decimals: number = 2): number {
    const newNumber = Number(`${number}`).toFixed(decimals);
    return parseFloat(newNumber);
}